var _style, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeartPlus1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n@keyframes a0_t { 0% { transform: translate(20px,20.6px) scale(1,1) translate(-16.3px,-15px); animation-timing-function: cubic-bezier(0,.7,.6,1); } 26.667% { transform: translate(20px,20.6px) scale(2,2) translate(-16.3px,-15px); } 100% { transform: translate(20px,20.6px) scale(2,2) translate(-16.3px,-15px); } }\n@keyframes a1_o { 0% { opacity: 1; animation-timing-function: cubic-bezier(0,.6,.5,1); } 26.667% { opacity: 0; } 100% { opacity: 0; } }\n@keyframes a2_t { 0% { transform: translate(10.8px,11.2px); animation-timing-function: cubic-bezier(0,.7,.4,1); } 57.8% { transform: translate(10.8px,-32.2px); } 100% { transform: translate(10.8px,-32.2px); } }\n@keyframes a2_o { 0% { opacity: 1; } 35.533% { opacity: 1; } 100% { opacity: 0; } }\n")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,20.6) translate(-16.3,-15)",
    style: {
      animation: "1.5s linear both a0_t"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4 8.5c-0.9-0.9-2-1.6-3.2-2.1c-1.2-0.5-2.4-0.8-3.7-0.8c-2.4 0-4.7 .9-6.5 2.6c-1.8-1.7-4.1-2.6-6.5-2.6c-1.3 0-2.6 .3-3.7 .8c-1.2 .5-2.3 1.2-3.2 2.1c-3.8 3.8-3.8 9.9 0 13.7l13.4 13.4l13.4-13.4c3.8-3.8 3.8-9.9 0-13.7Z",
    fill: "#fc8f81",
    transform: "translate(-3.7,-5.6)",
    style: {
      animation: "1.5s linear both a1_o"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.1,17.6) translate(-8.3,-6.4)",
    style: {
      animation: "1.5s linear both a2_t, 1.5s linear both a2_o"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6-2.7c-0.9-0.9-2-1.6-3.2-2.1c-1.2-0.5-2.4-0.8-3.7-0.8c-2.4 0-4.7 .9-6.5 2.6c-1.8-1.7-4.1-2.6-6.5-2.6c-1.3 0-2.6 .3-3.7 .8c-1.2 .5-2.3 1.2-3.2 2.1c-3.8 3.8-3.8 9.9 0 13.7l13.4 13.4l13.4-13.4c3.8-3.8 3.8-9.9 0-13.7Z",
    fill: "#fc8f81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7 0v12.8h-2.6v-9.9l-3 1v-2l5.3-1.9h.3Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 5.7v2.2h-8.8v-2.2h8.8Zm-3.2-3.5v9.3h-2.4v-9.3h2.4Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartPlus1);
export default __webpack_public_path__ + "static/media/heart-plus1.ee93a28b.svg";
export { ForwardRef as ReactComponent };